import retext from 'retext'
import retextSmartypants from 'retext-smartypants'

export function smartypants(text) {
  return String(retext().use(retextSmartypants).processSync(text))
}
